import Image from "next/image";
import { Facebook, Linkedin, Twitter, Github } from "@litonarefin/components/Icons";
import Link from "next/link";
import ReactAdminSubscribe from "@litonarefin/components/Footer/ReactAdminSubscribe";

function ReactAdminFooter({ subscribeData, footerOne, footerTwo, footerThree }) {
  const year = new Date().getFullYear();

  return (
    <footer className={`jlt-bg-[#1D2939] jlt-mt-44`}>
      <div className="jlt-container jlt-max-w-[1280px] jlt-mx-auto jlt-px-8 jlt-relative jlt-pb-12 sm:jlt-pb-16 md:jlt-pb-28 jlt-pt-[290px]">
        <div className="jlt-absolute -jlt-top-[149px] jlt-left-0 jlt-w-full jlt-px-4 xl:jlt-px-0">
          <div className="jlt-bg-white jlt-p-8 xl:jlt-p-[48px] jlt-rounded-2xl jlt-text-center jlt-flex jlt-flex-col jlt-items-center jlt-justify-center jlt-shadow-[0px_0px_48px_rgba(16,24,40,0.04)]">
            <h3 className="jlt-text-[#1D2939] jlt-text-4xl jlt-leading-[48px] jlt-mb-2">
              Subscribe our Newsletter
            </h3>
            <p className="jlt-text-[#667085] jlt-text-lg jlt-leading-6 jlt-font-medium">
              Join our newsletter and be the first to know about new product release, <br />
              discounts and useful resources!
            </p>

            <ReactAdminSubscribe listID={subscribeData?.listID} tagID={subscribeData?.tagID} />
          </div>
        </div>

        <div className="jlt-grid jlt-gap-y-8 md:jlt-grid-cols-2 lg:jlt-grid-cols-5">
          <div className="jlt-flex jlt-flex-col lg:jlt-col-span-2 jlt-text-center md:jlt-text-left lg:jlt-text-left jlt-items-center md:jlt-items-start lg:jlt-items-start">
            <Image
              src={"/light-logo.svg"}
              alt={"React Admin - Free React Admin Dashboard Templates"}
              width={156}
              height={28}
              sizes={"100vw"}
            />

            <div className="jlt-flex jlt-items-center jlt-text-center jlt-gap-x-3 jlt-mt-6">
              <a href="https://www.facebook.com/reactadmins" target="_blank">
                <Facebook />
              </a>
              <a href="https://x.com/reactmin" target="_blank">
                <Twitter />
              </a>
              <a href="https://github.com/reactadmins" target="_blank">
                <Github />
              </a>
              <a href="https://www.linkedin.com/company/reactadmin" target="_blank">
                <Linkedin />
              </a>
            </div>
          </div>
          <FooterMenu label="Products" menus={footerOne} />
          <FooterMenu label="Supports" menus={footerTwo} />
          <FooterMenu label="Company" menus={footerThree} />
        </div>
        <div className="jlt-flex jlt-flex-col md:jlt-flex-row jlt-justify-between jlt-items-center jlt-mt-24">
          <div className="jlt-text-[#EAECF0] jlt-mb-4 md:jlt-mb-0 jlt-text-center md:jlt-text-left">
            <Link prefetch={false} className="jlt-font-bold jlt-text-[#FB346D]" href={"/"}>
              {process.env.NEXT_PUBLIC_SOURCE_SITE}
            </Link>
            <div className="jlt-inline jlt-text-gray-300">
              {" "}
              &copy; 2014-{year} All rights reserved. Built with{" "}
              <div className="jlt-flex jlt-items-center jlt-gap-1">
                <svg
                  width="16"
                  height="14"
                  viewBox="0 0 16 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.6133 2.05298C13.2789 1.71736 12.8815 1.45107 12.4439 1.26937C12.0063 1.08767 11.5371 0.994141 11.0633 0.994141C10.5895 0.994141 10.1204 1.08767 9.68278 1.26937C9.2452 1.45107 8.84778 1.71736 8.51333 2.05298L8 2.57298L7.48666 2.05298C7.15221 1.71736 6.7548 1.45107 6.31721 1.26937C5.87962 1.08767 5.41047 0.994141 4.93666 0.994141C4.46285 0.994141 3.9937 1.08767 3.55612 1.26937C3.11853 1.45107 2.72112 1.71736 2.38666 2.05298C0.97333 3.46631 0.886663 5.85298 2.66666 7.66631L8 12.9996L13.3333 7.66631C15.1133 5.85298 15.0267 3.46631 13.6133 2.05298Z"
                    stroke="var(--primary)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>{" "}
                by{" "}
                <a href="https://pixarlabs.com" target="_blank" className="jlt-text-[#fff]">
                  Pixar Labs
                </a>
              </div>
            </div>
          </div>
          <Image src={"/payment.webp"} alt="Accepted payment methods - Visa, Mastercard, American Express, PayPal" width={194} height={24} sizes={"100vw"} />
        </div>
      </div>
      {/* <Fomo /> */}
    </footer>
  );
}

export default ReactAdminFooter;

const FooterMenu = ({ label = "", menus }) => {
  return (
    <div className="jlt-flex jlt-flex-col jlt-text-center md:jlt-text-left lg:text-left">
      <h3 className="jlt-text-[#fff] jlt-text-xl jlt-font-bold">{label}</h3>
      <div className="jlt-mt-8 ">
        <div className="jlt-flex jlt-flex-col jlt-items-center md:jlt-items-start jlt-gap-[10px]">
          {menus?.map((item, idx) => (
            <div key={idx} className="jlt-flex jlt-items-center jlt-gap-2">
              {item?.img_url ? (
                <div>
                  <img
                    src={item?.img_url}
                    alt={item?.img_alt || "Product Logo"}
                    width={24}
                    height={24}
                  />
                </div>
              ) : null}
              {!!item?.menu_target ? (
                <a
                  className="jlt-text-base jlt-font-semibold jlt-text-[#EAECF0] jlt-inline-block hover:jlt-text-[--primary] jlt-transition jlt-duration-150"
                  href={item?.menu_url || "/#"}
                  target="_blank"
                >
                  {item?.menu_label}
                </a>
              ) : (
                <Link
                  prefetch={false}
                  className="jlt-text-base jlt-font-semibold jlt-text-[#EAECF0] jlt-inline-block hover:jlt-text-[--primary] jlt-transition jlt-duration-150"
                  href={item?.menu_url || "/#"}
                >
                  {item?.menu_label}
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
